export default __webpack_public_path__ + "static/media/logo-text.cc18d51e.svg";